import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class UserSupportUserType {
  public readonly key = 'UserSupportUserType';
  public readonly enrollTrackRole = EnrollTrackRole.UserSupport;
}
